import { useStaticData } from '@mc/static-data-react'
import { GrowthContent } from '@mc/api'
import { reportError } from '@mc/next-newrelic'

import type { SubcategoryWithOutcome } from 'types/data'

import { HeroDesktop } from '../HeroDesktop'
import { HeroMobile } from '../HeroMobile'

type HeroProps = Parameters<typeof HeroMobile>[0]

export const SubcatPageHero = () => {
  const { subcatHeroCourses, subcatToOutcomes } = useStaticData<{
    subcatToOutcomes: SubcategoryWithOutcome
    subcatHeroCourses: GrowthContent[]
  }>()

  if (!subcatHeroCourses || subcatHeroCourses?.length < 2) {
    reportError(new Error('Missing subcatHeroCoursesMeta data'))
    return null
  }

  const [courseB, courseA] = subcatHeroCourses

  if (!(courseA && courseB)) {
    reportError(new Error('Missing featured course data for subcat hero'))
    return null
  }

  const props = {
    heading: subcatToOutcomes.name,
    courseA,
    courseB,
  } satisfies HeroProps

  return (
    <>
      <HeroMobile {...props} />
      <HeroDesktop {...props} />
    </>
  )
}
